module.exports = __webpack_public_path__ + "img/83.68b56334.jpg";